import { FindexClient } from '@/integrations/findex'

export const checkHealthOrShowError = async () => {
  const router = useRouter();
  const result = await FindexClient.healthCheck()
  if (result !== true) {
    router.push('/error')
  }
}
